<div
  class="sidenav-mobile-shell"
  #mobileShell
  [class.is-open]="isSmallScreen() && sidenavService.sidenavOpen()"
>
  @if (isSmallScreen() && sidenavService.sidenavOpen()) {
    <button
      type="button"
      class="sidenav-backdrop"
      [attr.aria-label]="'jobboard.platform.sidenav.close-menu' | transloco"
      (click)="sidenavService.closeSidenav()"
    ></button>
  }
  <div class="sidenav" [class.collapsed]="isSidenavCollapsed()" #sidenav>
    <div class="logo" [routerLink]="['/dashboard']">
      @switch (themingService.theme) {
        @case ('light') {
          @if (sidenavService.sidenavOpen()) {
            <img
              src="./assets/img/logos/titled/dark_titled_dark.png"
              alt="catch logo"
            />
          } @else {
            <img src="./assets/img/logos/solid/dark.png" alt="catch logo" />
          }
        }
        @case ('dark') {
          @if (sidenavService.sidenavOpen()) {
            <img
              src="./assets/img/logos/titled/white_titled_white.png"
              alt="catch logo"
            />
          } @else {
            <img src="./assets/img/logos/solid/white.png" alt="catch logo" />
          }
        }
      }
    </div>

    <div class="search">
      <div class="row">
        <div class="col-12 form-group icon-start m-0 cmdk-search">
          <fa-icon [icon]="icons.search"></fa-icon>
          <input
            type="text"
            class="form-control auto-height"
            [placeholder]="'jobboard.platform.cmdk.search.placeholder' | transloco"
            readonly
            aria-haspopup="dialog"
            (mousedown)="openCmdkFromSidenav($event)"
            (keydown.enter)="openCmdkFromSidenav($event)"
            (keydown.space)="openCmdkFromSidenav($event)"
          />
          @if (sidenavService.sidenavOpen()) {
            <app-platform-kbd
              class="cmdk-search__kbd"
              [keys]="cmdkKeys()"
              [ariaLabelOverride]="cmdkAriaLabel()"
            ></app-platform-kbd>
          }
        </div>
      </div>
    </div>

    <div class="menus">
      <ul class="menu-list main">
        <li routerLink="/dashboard" routerLinkActive="active" position="right" [tooltip]="sidenavService.sidenavOpen() ? undefined : ('jobboard.platform.sidenav.dashboard' | transloco)">
          <fa-icon [icon]="icons.home"></fa-icon>
          <p>{{ 'jobboard.platform.sidenav.dashboard' | transloco }}</p>
        </li>
        <li routerLink="/applications" routerLinkActive="active" position="right" [tooltip]="sidenavService.sidenavOpen() ? undefined : ('jobboard.platform.sidenav.applications' | transloco)">
          <fa-icon [icon]="icons.applications"></fa-icon>
          <p>{{ 'jobboard.platform.sidenav.applications' | transloco }}</p>
        </li>
        <li routerLink="/jobs" routerLinkActive="active" position="right" [tooltip]="sidenavService.sidenavOpen() ? undefined : ('jobboard.platform.sidenav.jobs' | transloco)">
          <fa-icon [icon]="icons.briefcase"></fa-icon>
          <p>{{ 'jobboard.platform.sidenav.jobs' | transloco }}</p>
        </li>
        <app-platform-sidenav-group
          position="right"
          [tooltip]="sidenavService.sidenavOpen() ? undefined : ('jobboard.platform.sidenav.profile' | transloco)"
          [icon]="icons.user"
          [labelKey]="'jobboard.platform.sidenav.profile'"
          [routerLink]="['/profile']"
          [children]="profileChildren"
          [collapsed]="isSidenavCollapsed()"
        ></app-platform-sidenav-group>
        <app-platform-sidenav-group
          position="right"
          [tooltip]="sidenavService.sidenavOpen() ? undefined : ('jobboard.platform.sidenav.settings' | transloco)"
          [icon]="icons.settings"
          [labelKey]="'jobboard.platform.sidenav.settings'"
          [routerLink]="['/settings']"
          [children]="settingsChildren"
          [collapsed]="isSidenavCollapsed()"
        ></app-platform-sidenav-group>
      </ul>
    </div>

    <div class="bottom-bar">
      <ul class="menu-list">
        <li
          routerLink="/"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          position="right"
          [tooltip]="sidenavService.sidenavOpen() ? undefined : ('jobboard.platform.sidenav.leave' | transloco)"
        >
          <fa-icon [icon]="icons.switch"></fa-icon>
          <p>{{ 'jobboard.platform.sidenav.leave' | transloco }}</p>
        </li>
        <li (click)="userPopover.toggle($event)">
          <app-platform-avatar-placeholder
            class="avatar"
            [initials]="userInitials()"
          ></app-platform-avatar-placeholder>
          <p>{{ user().firstName }} {{ user().lastName }}</p>
          <fa-icon [icon]="icons.ellipsis"></fa-icon>
        </li>
      </ul>
    </div>
  </div>
</div>

<p-popover
  [unstyled]="true"
  #userPopover
  [appendTo]="popoverAppendTo()"
  [autoZIndex]="!isSmallScreen()"
  [styleClass]="popoverStyleClass()"
>
  <ng-template #content let-dismissUserPopover="closeCallback">
    <app-platform-sidenav-user [closePopover]="dismissUserPopover"></app-platform-sidenav-user>
  </ng-template>
</p-popover>

<app-platform-cmdk></app-platform-cmdk>
